module.exports = __webpack_public_path__ + "static/media/save_share.4df0ad23.mp4";